  <div>
    <div class="sx-guide__content">
      <div class="sx-guide__image-panel">
        @if(loginMessage?.image){
          <img class="sx-guide__image" src="{{ loginMessage.image }}">
        }
      </div>
      <div class="sx-guide__text">
        @if(loginMessage?.heading){
          <h3 [innerHTML]="loginMessage.heading"></h3>
        }
        @if(loginMessage?.mainText){
          <div [innerHTML]="loginMessage.mainText | safeHtml" appRouterLink></div>
        }
      </div>
    </div>
  </div>
